
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21.6a9.6 9.6 0 009.6-9.6 9.6 9.6 0 10-9.6 9.6zM5.198 9.633a7.214 7.214 0 012.295-3.248c.322.49.876.815 1.507.815A1.8 1.8 0 0110.8 9v.6a2.4 2.4 0 004.8 0c0-1.128.778-2.075 1.827-2.331a7.172 7.172 0 011.773 4.73c0 .41-.034.81-.1 1.201H18a2.4 2.4 0 00-2.4 2.4v2.637a7.167 7.167 0 01-3.6.963v-2.4a2.4 2.4 0 00-2.4-2.4A2.4 2.4 0 017.2 12a2.4 2.4 0 00-2.002-2.367z","fill":"#fff"}})])
          )
        }
      }
    